import { getCurrentHub, init } from '@sentry/browser';
import { BrowserTracing, addExtensionMethods as sentryAddExtensionMethods } from '@sentry/tracing';
import { Environment } from '@environment/interfaces';
import { ONE_SECOND_MS } from '@shared/utils/constants';

const CLOSE_TIMEOUT_MS = 2 * ONE_SECOND_MS;

export function initSentry(
  enabled: boolean,
  environment: Environment,
  addExtensionMethods: boolean,
  includeBrowserTracing: boolean
): void {
  init({
    enabled,
    dsn: 'https://777eb4bb802841afac62dcfc1612f769@o4504227135291392.ingest.sentry.io/4504739436429312',
    integrations: includeBrowserTracing ? [new BrowserTracing()] : [],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: environment.type,
    release: environment.npmPackageVersion,
  });

  if (addExtensionMethods) {
    sentryAddExtensionMethods();
  }
}

export async function closeSentry(): Promise<void> {
  const client = getCurrentHub()?.getClient();
  if (client) {
    await client.close(CLOSE_TIMEOUT_MS);
  }
}
